const hasVisit = (state) => state.visit && state.visit.id

const hasDocumentInfo = (state) => state.userInfo && state.userInfo.document

export default {
  hasVisit,
  hasDocumentInfo,
}
